const featureItems = [
  {
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    desc: '全程无任何广告干扰，无需等待跳过，专注观影体验，每一秒都沉浸在精彩剧情中。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '1080P超清画质，支持多线路切换，网络自适应码率，低带宽也能流畅播放不卡顿。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '最新电影、热播剧集、热门综艺每日同步更新，追剧不再等待，精彩内容第一时间送达。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-gray-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">平台优势</h2>
            <p className="text-sm text-gray-500 mt-2">为什么千万用户选择90影视</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {featureItems.map((item, idx) => (
              <div key={idx} className="bg-white rounded-xl p-6 md:p-8 border border-gray-100 hover:border-brand-100 transition-all duration-300 group">
                <div className="w-12 h-12 rounded-xl bg-brand-50 flex items-center justify-center mb-5 group-hover:bg-brand-100 transition-colors duration-300">
                  <i className={`${item.icon} text-brand-600 text-xl w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}